export const READ = "READ";
export const READ_LIST = "READ_LIST";
export const CREATE = "CREATE";
export const DELETE = "DELETE";
export const UPDATE = "UPDATE";

export const SUCCESS = "SUCCESS";
export const ERROR = "ERROR";
